import { useOnboardingData } from "@apis/onboarding";
import { useTheme } from "styled-components/native";
import { useTranslation } from "react-i18next";
import { useOrgSettingsSlice } from "@redux/slices/orgSettingsSlice";
import {
  OnboardingScreenPlatform,
  OnBoardingTypes,
} from "@scenes/splash-screen/types";
import { useUserInfo } from "@redux/slices/userInfoSlice";
import { useEffect } from "react";
import Routes from "@navigations/Routes";
import { useOnboardingDataSlice } from "@redux/slices/OnboardingDataSlice";
import { useSelector } from "react-redux";
import { navigate } from "@navigations/utils/RootNavigation";

const usePostOnboarding = (
  allow_navigation: boolean,
  onNavigationSucceeded?: any,
  navigationProp?: any
) => {
  const theme = useTheme();
  const { i18n } = useTranslation();
  const { settings, initStatus } = useOrgSettingsSlice();
  const postOnboardingCheck = useSelector(
    (state: any) => state.appState?.postOnboardingCheck
  );
  const userInfo = useUserInfo();

  let defaultNavigation;
  try {
    defaultNavigation = navigate;
  } catch (error) {
    defaultNavigation = null;
  }
  const navigation =
    navigationProp !== undefined ? navigationProp : defaultNavigation;
  const {
    savePostOnboardingData,
    setPostOnBoardingTimeStamp,
    clearPostOnboardingData,
  } = useOnboardingDataSlice();

  const data = useOnboardingData(
    settings?.organization?.id,
    theme.isLargeScreen
      ? OnboardingScreenPlatform.DESKTOP
      : theme.isTablet
      ? OnboardingScreenPlatform.WEB
      : OnboardingScreenPlatform.MOBILE,
    i18n.language ?? "en",
    !userInfo?.onBoardingStatus() || allow_navigation,
    OnBoardingTypes.post_login,
    userInfo.user.price_mode
  );

  useEffect(() => {
    if (data.data) {
      if (data?.data?.data?.length > 0) {
        savePostOnboardingData(data?.data?.data);
        setPostOnBoardingTimeStamp(Date.now());

        if (
          (initStatus?.onboarding_screen &&
            postOnboardingCheck &&
            !userInfo?.onBoardingStatus()) ||
          allow_navigation
        ) {
          const params = {
            isPostOnboarding: true,
            presentation: "fullScreenModal",
          };
          if (allow_navigation && onNavigationSucceeded) {
            onNavigationSucceeded(true);
          }
          if (navigation) {
            navigate(Routes.PostOnBoardingScreen, params);
          }
        }
      } else {
        if (allow_navigation && onNavigationSucceeded) {
          onNavigationSucceeded(true);
        }

        clearPostOnboardingData();
      }
    }
  }, [data.data, allow_navigation]);

  useEffect(() => {
    if (allow_navigation && onNavigationSucceeded) {
      onNavigationSucceeded(true);
    }
  }, [data.isError]);
};

export default usePostOnboarding;
